module.exports = __webpack_public_path__ + "img/3.7dd2ad37.png";